import { getUserIdFromStorage, storeUserId } from "./storage"

export const runsOnServerSide = typeof window === "undefined"

/**
 * This function is a copy/paste from the french subscription flow
 * @returns a random user id
 */
export function generateUserId() {
  let userId = "DAL_" + Math.random().toString(36).substring(2, 4)
  userId += "_" + Date.now().toString()

  return userId
}

export function getOrCreateUserId(): string {
  if (runsOnServerSide) {
    return generateUserId()
  }
  const stored = getUserIdFromStorage()
  if (stored) {
    return stored
  }
  const newId = generateUserId()
  storeUserId(newId)
  return newId
}

//https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
export function generatePetId() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

// Source: https://www.freecodecamp.org/news/javascript-debounce-example/
export function debounce(func: (...args: any[]) => any, timeout = 100) {
  let timer: NodeJS.Timeout
  return (...args: any[]) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(args)
    }, timeout)
  }
}


/**
 * Détermine si l'utilisateur vient d'une landing page
 * @param meta Les meta données de la quote (doit contenir from_lp ou utm)
 * @returns true si l'utilisateur vient d'une landing page
 */
export function isFromLandingPage(
  meta?: { from_lp?: boolean; utm?: Record<string, string | undefined> | null } | null
): boolean {
  if (!meta) {
    return false
  }
  if (meta.from_lp !== undefined) {
    return meta.from_lp
  }
  if (meta.utm) {
    return Object.values(meta.utm).some((value) => Boolean(value && value.trim() !== ""))
  }
  return false
}
